import type { DeleteContractMutationOptions } from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { UUID } from '~/types/common';

import { queryKeysContract } from '../queryKeys';

import { deleteContract } from './deleteContract';

/**
 * Custom hook for deleting a contract.
 *
 * @param options - Optional mutation options.
 * @returns An object containing the mutation function and related properties.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/delete_contract_contracts__contract_id__delete
 */
export const useMutationDeleteContract = (
  options?: DeleteContractMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, UUID>({
    mutationFn: async (contractId: UUID) => deleteContract(contractId),
    onSuccess() {
      void queryClient.invalidateQueries({
        queryKey: queryKeysContract.getAll(),
      });
    },
    ...options,
  });
};
